import i18n from '@/i18n';
import { Icon, IconType } from '@/lib/enum/Icon';
import { StorageEnum } from '@/lib/enum/StorageEnum';
import { FilterItem, toFilterItem } from '@/lib/filters/filterHelpers';
import { ShiftStatusEnum } from '@/lib/schedule-v2/scheduleV2Functions';
import { EmployeeEmploymentTypeEnum } from '../../../api/v1';

export enum SortOrders {
  Name = 'name',
  Role = 'role',
  Hours = 'hours',
  ShiftCount = 'shiftCount',
  StartTime = 'startTime',
}

export enum SortDirections {
  Ascending = 'ascending',
  Descending = 'descending',
}

export type ScheduleSortOrderType = {
  sortBy: SortOrders;
  direction: SortDirections;
};

export type ScheduleV2FilterType = {
  scheduleId: number | null;
  locationId: FilterItem<number>[];
  areaIds: FilterItem<number>[];
  jobRoleIds: FilterItem<number>[];
  tagIds: FilterItem<number>[];
  daysOfWeek: FilterItem<string>[];
  startTime: Date | null;
  endTime: Date | null;
  shiftStatus: FilterItem<ShiftStatusEnum>[];
  employeeIds: FilterItem<number>[];
  employeeJobRoleIds: FilterItem<number>[];
  employeeGroupIds: FilterItem<number>[];
  employeeAttributeIds: FilterItem<number>[];
  employmentTypes: FilterItem<EmployeeEmploymentTypeEnum>[];
  hideEmployeesWithoutFilteredShifts: FilterItem<boolean>[];
  sortOrder: ScheduleSortOrderType;
};

export const getScheduleFilterItemIcon = (
  key: keyof ScheduleV2FilterType,
): IconType =>
  [
    'employeeIds',
    'employeeJobRoleIds',
    'employeeGroupIds',
    'employeeAttributeIds',
    'employmentTypes',
  ].includes(key)
    ? Icon.User
    : Icon.CalendarDay;

export const getDefaultFilter = (): ScheduleV2FilterType => ({
  scheduleId: null,
  locationId: [],
  areaIds: [],
  jobRoleIds: [],
  tagIds: [],
  daysOfWeek: [],
  startTime: null,
  endTime: null,
  shiftStatus: [
    toFilterItem(
      ShiftStatusEnum.All,
      i18n.tc(`enum.shiftStatus.${ShiftStatusEnum.All}`),
      'ShiftStatus',
      getScheduleFilterItemIcon('shiftStatus'),
    ),
  ],
  employeeIds: [],
  employeeJobRoleIds: [],
  employeeGroupIds: [],
  employeeAttributeIds: [],
  employmentTypes: [],
  hideEmployeesWithoutFilteredShifts: [],
  sortOrder: {
    sortBy: SortOrders.Name,
    direction: SortDirections.Ascending,
  },
});

export const storedScheduleFilterId = (
  companyId: number,
  employeeId: number,
): string => `${StorageEnum.ScheduleFilter}C${companyId}E${employeeId}`;
